export default __webpack_public_path__ + "static/media/lauta.de39611d.jfif";